(function () {
  'use strict';

  const HOVER_DELAY = 100;

  function handleize(str) {
    return str
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .trim()
      .replace(/[\s_]+/g, '-');
  }

  function getNavLinks() {
    const overflowList = document.querySelector('overflow-list');
    if (overflowList && overflowList.shadowRoot) {
      const links = overflowList.shadowRoot.querySelectorAll('.menu-list__link');
      if (links.length) return Array.from(links);
    }
    const lightLinks = document.querySelectorAll('.menu-list__link');
    if (lightLinks.length) return Array.from(lightLinks);
    return [];
  }

  function initMegaMenus() {
    const panels = document.querySelectorAll('[data-mega-menu-panel]');
    if (!panels.length) return;

    // Map: key → panel wrapper
    // Key is either the handleized parent_link text, OR the raw value (e.g. "#")
    const panelMap = {};
    panels.forEach(panel => {
      const key = panel.getAttribute('data-parent-link');
      if (key) panelMap[key] = panel.closest('section, .mega-menu-section') || panel;
    });

    const navLinks = getNavLinks();
    if (!navLinks.length) {
      console.warn('[MegaMenu] No nav links found. Shadow root may not be ready.');
      return;
    }

    let closeTimer = null;

    function showPanel(sectionEl, triggerEl) {
      clearTimeout(closeTimer);
      Object.values(panelMap).forEach(el => el.classList.remove('is-visible'));
      navLinks.forEach(l => l.setAttribute('aria-expanded', 'false'));
      sectionEl.classList.add('is-visible');
      if (triggerEl) triggerEl.setAttribute('aria-expanded', 'true');
    }

    function hideAll() {
      Object.values(panelMap).forEach(el => el.classList.remove('is-visible'));
      navLinks.forEach(l => l.setAttribute('aria-expanded', 'false'));
    }

    navLinks.forEach(link => {
      const titleEl = link.querySelector('.menu-list__link-title') || link;
      const handle = handleize(titleEl.textContent.trim());

      // PRIMARY: match by handleized text (e.g. "other-jewelry")
      // FALLBACK: if the link's href is "#", also check panelMap["#"]
      const href = (link.getAttribute('href') || '').trim();
      const isHashLink = href === '#' || href === '';

      let sectionEl = panelMap[handle];

      // If no text-match found and this is a # link, try matching by "#" key
      if (!sectionEl && isHashLink && panelMap['#']) {
        sectionEl = panelMap['#'];
      }

      // Also: if the panelMap has a "#" key, match any nav link whose href is "#"
      // regardless of text match (covers renamed/translated nav items)
      if (!sectionEl && isHashLink) {
        // Already covered above, but be explicit
        sectionEl = panelMap['#'] || null;
      }

      if (!sectionEl) return;

      const li = link.closest('li');
      if (li) li.classList.add('has-mega-menu');

      link.addEventListener('mouseenter', () => {
        showPanel(sectionEl, link);
      });

      link.addEventListener('focus', () => {
        showPanel(sectionEl, link);
      });

      link.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(hideAll, HOVER_DELAY);
      });

      sectionEl.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
      });

      sectionEl.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(hideAll, HOVER_DELAY);
      });
    });

    document.addEventListener('click', e => {
      const inPanel = e.target.closest('#mega-menu-container');
      const inNav = e.composedPath().some(el =>
        el?.classList?.contains('menu-list__link') ||
        el?.tagName === 'OVERFLOW-LIST'
      );
      if (!inPanel && !inNav) hideAll();
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') hideAll();
    });
  }

  function waitForShadowAndInit(retries = 10) {
    const overflowList = document.querySelector('overflow-list');
    if (overflowList && overflowList.shadowRoot) {
      initMegaMenus();
    } else if (retries > 0) {
      setTimeout(() => waitForShadowAndInit(retries - 1), 150);
    } else {
      console.warn('[MegaMenu] overflow-list shadow root never appeared.');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => waitForShadowAndInit());
  } else {
    waitForShadowAndInit();
  }

  document.addEventListener('shopify:section:load', () => waitForShadowAndInit());
  document.addEventListener('shopify:section:reorder', () => waitForShadowAndInit());

})();